import api from "./axios";

// Flitt 3DS flow (legacy)
export const initiate3DSecure = async (paymentData) => {
  const response = await api.post("/payment/3dsecure/step1", paymentData);
  return response.data;
};

export const complete3DSecure = async (completionData) => {
  const response = await api.post("/payment/3dsecure/step2", completionData);
  return response.data;
};

// MonRem payment flow
export const monremPurchase = async (paymentData) => {
  const response = await api.post("/monrem/purchase", paymentData);
  return response.data;
};

export const monremCheckStatus = async (orderId) => {
  const response = await api.post("/monrem/status", { order_id: orderId });
  return response.data;
};

/** MonRem merchant API: re-dispatch server callback (async worker). */
export const monremRequestCallbackRetry = async (providerTransactionId) => {
  const id = encodeURIComponent(String(providerTransactionId));
  const response = await api.post(`/monrem/transactions/${id}/callback`);
  return response.data;
};

/** Same as retry but uses our `order_id` to resolve provider transaction id. */
export const monremRequestCallbackByOrder = async (orderId) => {
  const id = encodeURIComponent(String(orderId));
  const response = await api.post(`/monrem/orders/${id}/request-callback`);
  return response.data;
};
